import { useMutation } from '@redwoodjs/web';

import { showErrorToast } from 'src/components/Toasts/toast';
import { VALIDATE_VAT_NUMBER } from 'src/graphql/mutations/vat-validation';

// eslint-disable-next-line import/prefer-default-export
export const useValidateVAT = () => {
    const [validateVATNumber, { loading: validatingVatNumber }] = useMutation(VALIDATE_VAT_NUMBER);

    const onValidateVAT = async (
        vatNumber: string,
        onError?: () => void,
        onSuccess?: () => void
    ) => {
        await validateVATNumber({
            variables: { vatNumber },
            onCompleted: () => {
                onSuccess && onSuccess();
            },
            onError: (err) => {
                showErrorToast(err.message);
                onError && onError();
            },
        });
    };

    return { validatingVatNumber, onValidateVAT };
};
